import axios from "axios";

import fetchEnv from "../../../../utils/FetchEnv";

const umApiUrl = fetchEnv()?.REACT_APP_APIURL_ADMIN;

const loginData = JSON.parse(localStorage.getItem("loginResponse"));
const userName = loginData?.object?.username;

export const getUserDetails = (data) => {
  return axios.get(`${umApiUrl}/authservice/v1/users/${data.userId}`);
};

export const updateUserDataByID = (data) => {
  return axios.put(`${umApiUrl}/authservice/v1/users/${data.email}`, data);
};

export const changePasswordMethod = (data) => {
  return axios.put(`${umApiUrl}/change-password`, data);
};

export const logoutAsync = () => {
  return axios.get(`${umApiUrl}/authservice/v1/users/${userName}/logout`);
};
